import { Directive } from '@angular/core';

/**
 * Marks content projected into the facet panel's head, between the "Filteren" title and the facet
 * groups. Lets consumers supply panel-head content from outside this library; the head renders as soon
 * as a title, a summary, or marked content is present.
 */
@Directive({
    selector: '[shFacetPanelHead]',
    standalone: true
})
export class ShFacetPanelHeadDirective {}
